import {ATTENDANCE_STATUS} from '../../CodeMaster'
import React from 'react'
import styled, {css} from 'styled-components'

interface Props {
    meetingAttendanceStatus: ATTENDANCE_STATUS
}

const ResidentMeetingAttendanceStatusTag: React.FC<Props> = props =>
    <StyledStatusTag {...props}>{props.meetingAttendanceStatus.label}</StyledStatusTag>

ResidentMeetingAttendanceStatusTag.displayName = 'ReservationStatusTag'
export default ResidentMeetingAttendanceStatusTag

const StyledStatusTag = styled.div<Props>`
  width: 90px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  display: inline-block;
  background: ${props => {
    switch (props.meetingAttendanceStatus) {
      case ATTENDANCE_STATUS.ATTEND:
        return css`rgb(206, 230, 244)`
      case ATTENDANCE_STATUS.PROXY_ATTEND:
        return css`rgb(225, 240, 248) `
      case ATTENDANCE_STATUS.ABSENT:
        return css`rgb(252, 232, 200)`
      default:
        return css`rgb(236, 236, 236)`
    }
  }};
`

